import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getTourDate } from 'entities/tour/ui/special-tours/libs/getTourDate.ts'

import { SpecialTour } from 'shared/api/tours/search'
import { priceShow } from 'shared/lib/priceShow.ts'
import { ImageLazy } from 'shared/ui/image-lazy'
import { MBonusDiscount } from 'shared/ui/mbonus/mbonus-discount'

import s from './styles.module.scss'

interface Props {
  data?: SpecialTour
  onClick: () => void
}

export const SpecialToursCardMini = ({ data, onClick }: Props) => {
  const { t } = useTranslation()

  const titleText = `${data?.state?.name}, ${data?.hotel_name}`
  const dateText = getTourDate(data)

  return (
    <div
      className={s.wrapper}
      onClick={onClick}
    >
      <div className={s.header}>
        <div className={s.titles}>
          <p className={clsx('bold-14', s.hotToursTitle)}>{titleText}</p>
          <div className={clsx(s.texts)}>
            <p className={clsx('medium-12', s.title)}>{dateText}</p>
            <p className={clsx('regular-12', s.subtitle)}>
              {t('tours_block.nights_and_tourists', {
                nights: data?.nights,
                passengers: data?.adult,
              })}
            </p>
          </div>
        </div>
        <ImageLazy
          alt="tour image"
          src={data?.image}
          className={s.toursImage}
        />
      </div>

      <div className={s.hotToursInfo}>
        <div className={s.price}>
          <div className={s.currentPrice}>
            <div className={s.box}>
              <p className={clsx('bold-14', s.hotToursDescr)}>
                {`${t('price_start', { price: priceShow(String(data?.price || 0)) })}`}
              </p>

              <p className={clsx('semi-bold-12', s.dollar)}>
                (~&#36;
                {priceShow(String(Math.ceil(Number(data?.price_usd || 0))))})
              </p>
            </div>

            <MBonusDiscount title={`${3}% ${t('mbonus_discount')}`} />
          </div>
        </div>
      </div>
    </div>
  )
}
